import styled from "styled-components"
import { Button_s, Colors, H4 } from "styles/app-styles"
import DataTable_s from "components/table/data-table-styles"
import { SectionFormWell } from "styles/form-styles"

export const MarketLease_s = styled.div`
  height: calc(100vh - 155px);
  overflow: auto !important;
  position: fixed;
  width: 100%;

  .p-paginator {
    bottom: 0px;
    .p-connected-overlay-enter-done { background: white; }
  }
  .market-lease-table-container {
    height: 100%;
  }
  .p-datatable-scrollable-wrapper {
    height: 100%;
    margin-bottom: 45px;
  }
  .p-datatable-scrollable-body {
    min-height: 300px;
  }
`

export const MarketLeaseTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  height: 100%;
  padding-bottom: 0 !important;

  div.p-datatable-scrollable-wrapper {
    width: calc(100vw - 90px);
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .p-paginator {
    bottom: 0px;
  }

  .billion-input {
    width: 120px;
  }
  .named-item-state-input {
    width: 200px;
  }
  .lc-amount-type {
    width:200px;
  }
  .recoverypool {
    width: 310px;
  }
  .reporttag {
    width: 120px;
  }
  .pro-rata-type {
    width: 114px;
  }
  .pro-rata-percent {
    width: 66px;
  }
  .stop-type {
    width: 146px;
  }
  .stop {
    width: 100px;
  }
  .short-input {
    width: 100px;
  }

  // Detailed Amt //

  .detailed-amt-container {
    height: 400px;
  }

  // Pro Rata //

  .pro-rata-container {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    height: 470px;
    width: 100%;
    .cap-details {
      max-height: 245px;
      overflow: auto;
    }
  }
  .pro-rata-form {
    align-items: flex-start;
    grid-area: 1 / 1 / 2 / 3;
    z-index: 1;
  }
`

export const Cap_s = styled.div`
  background: white;
  border: 1px solid ${Colors.towerGrey};
  box-shadow: -2px 2px 3px 0px rgba(0,0,0,0.12);
  flex-direction: column;
  grid-area: 1 / 2 / 1 / 3;
  height: 504px;
  padding: 20px;
  position: absolute;
  right: 0;
  top: 74px;
  width: 600px;
  z-index: 2;

  ${SectionFormWell}{
    margin: 20px 0;
  }
  ${H4}{
    margin-bottom: 15px;
  }
  ${H4} + hr {
    color: ${Colors.towerGrey};
    margin-bottom: 15px;
    size: 1px;
  }
  .p-listbox-list-wrapper {
    padding: 5px 10px 5px 5px;
  }
`

interface CapBtnProps {
  hasCap: boolean
}

export const CapButtons_s = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  a {
    margin-left: 20px;
    svg { height: 16px; width: 16px; }
    .r-svg { fill: ${Colors.blackPearl}; }
  }
`

export const CapButton_s = styled(Button_s)<CapBtnProps>`
  width: 75px;
  ${props => props.hasCap && `
  &:before {
    background: ${Colors.denim};
    border-radius: 100%;
    content: '';
    margin: 1px 0 0 32px;
    position: absolute;
    height: 12px;
    width: 12px;
  }
`}
`

export const Details_s = styled.div`
  background: white;
  border: 1px solid ${Colors.towerGrey};
  box-shadow: -2px 2px 3px 0px rgba(0,0,0,0.12);
  flex-direction: column;
  grid-area: 1 / 2 / 1 / 3;
  height: 461px;
  padding: 20px;
  position: absolute;
  right: 0;
  top: 74px;
  width: 35%;
  z-index: 2;

  ${SectionFormWell}{
    margin: 20px 0;
  }

  .detailed-amt-details {
    max-height: 350px;
    overflow-x: scroll;

    input { width: 160px; }
  }
`

interface DetailBtnProps {
  hasDetails: boolean
}

export const DetailsButton_s = styled(Button_s)<DetailBtnProps>`
  align-items: center;
  background: ${Colors.inputFocus} !important;
  display: flex;
  font-size: 16px;
  height: 50px;
  margin-right: 15px;
  padding-right: 30px;
  position: absolute;
  right: -15px;
  top: 74px;
  width: 120px;
  z-index: 2;
  svg {
    height: 22px;
    width: 22px;
  }
`